module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-regular-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-regular-webfont.svg
// module id = 48
// module chunks = d-game